// import { Modal } from "@mui/material";
import { Box, Modal, Slider, Typography } from '@mui/material';
import { CalculateIcon, CloseIcon, Flex, IconButton, Button, Image, Input, Link, Text, LinkExternal } from '@pancakeswap/uikit';
import Balance from 'components/Balance';
import React, { useState, FC, useEffect } from 'react';
import styled from 'styled-components';
import headerimage from '../../../../assets/images/headerimage.png'
import RoiCalculatorModal from './RoiCalculatorModal';
import { ethers, BigNumber } from "ethers";
import { getDrivenFarmAddress, getTokenAddress } from "utils/addressHelpers";
import { getContract } from "utils/contractHelpers";
import DrivenFarmABI from "ABI/DrivenFarmABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import { useWeb3React } from '@web3-react/core';
import LpTokenABI from './../../../../ABI/LpTokenABI.json'
import FarmRoiCalculatorModal from './FarmRoiCalculatorModal';
import { setPidx } from 'store/IndexSlice';
import { useDispatch, useSelector } from 'react-redux';
import LoopIcon from '@mui/icons-material/Loop';




interface StakeFarmModalProps {
    onClose: () => void;
    openfarmmodal: boolean;
    isRemovingStake?: boolean
    pool?: any
    stack?: string
}

const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    // border-bottom: 1px solid #00FED9;
    display: flex;
    padding: 24px 24px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ModalBody = styled(Box)`
    flex-direction: column;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    padding: 24px;
`

const StyledBalanceInput = styled(Box)`
    background-color: #1A3342;
    border: 1px solid #00FED9;
    border-radius: 16px;
    box-shadow: ${({ theme }) => theme.shadows["inset"]};
    padding: 8px 16px;
`;

const StyledInput = styled(Input) <{ textAlign?: string }>`
  background: transparent;
  border-radius: 0;
  color : white;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;
  /* margin-top: 10px; */
  text-align: ${({ textAlign = "left" }) => textAlign};
  border: none;

  ::placeholder {
    color: #B1B3CB;
  }

  &:focus:not(:disabled) {
    box-shadow: none;
  }
`;

const UnitContainer = styled(Text)`
    margin-left: 4px;
    text-align: right;
    color: ${({ theme }) => theme.colors.textSubtle};
    white-space: nowrap;
`;

const PercentageButton = styled(Box)`
    flex-grow: 1;
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 20px;
    font-size: 12px;
    background-color: #00FED9;
    box-shadow: none;
    color: rgb(15, 33, 49);
    padding: 4px 16px;
    margin-right: 2px;
    margin-left: 2px;
`
const AnnualRoiContainer = styled(Flex)`
  cursor: pointer;
`
const AnnualRoiDisplay = styled(Text)`
  width: 72px;
  max-width: 72px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
`

const StyledLink = styled(Link)`
  /* width: 100%; */
  width: 50%;
  margin-top:18px;
`
const GetToken = styled(Link)`
  width: 100%;
  margin-top:18px;
`

const ConfirmButton = styled(Button)`
    width:50%;
    align-items: center;
    border: 0px none;
    border-radius: 16px !important;
    box-shadow: rgba(14, 14, 44, 0.4) 0px -1px 0px 0px inset !important;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s !important;
    height: 48px;
    padding: 0px 24px;
    background-color: #00FED9 ;
    color: black;
    margin-top: 24px;
    margin-left:24px;
`
const GetSymbol = styled(Button)`
    align-items: center;
    border-radius: 16px !important;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s !important;
    height: 48px;
    padding: 0px 24px;
    background-color: transparent;
    border: 2px solid #00FED9 !important;
    box-shadow: none;
    color: white !important;
    width: 100%;
    margin-top: 8px !important;
`

const PLinkExternal = styled(LinkExternal)`
  text-decoration : none;
`

const StakeFarmModal: React.FunctionComponent<StakeFarmModalProps> = ({
    openfarmmodal,
    // open,
    onClose,
    pool,
    stack,
    isRemovingStake = false

}) => {
    // console.log(pool)

    let balance = !isRemovingStake ? (pool.user != undefined ? parseFloat(ethers.utils.formatUnits(pool.user?.lpTokenBalance, pool?.lpTokenDecimal).toString()) : 0) : (pool.user != undefined ? parseFloat(ethers.utils.formatUnits(pool.user?.stakeamount, pool?.lpTokenDecimal).toString()) : 0);
    // let balance = pool.user != undefined ? parseFloat(ethers.utils.formatUnits(pool.user?.lpTokenBalance, pool?.lpTokenDecimal).toString()) : 0
    // let stakeamount = pool.user != undefined ? parseFloat(ethers.utils.formatUnits(pool.user?.stakeamount, pool?.lpTokenDecimal).toString()) : 0

    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
    // console.log("allowance", account)
    const [RoiCalculatoropen, setRoiCalculatorOpen] = React.useState(false);
    const [stackvalue, setStakeValue] = useState("0");
    const [usdvalue, setUSDvalue] = useState(0);
    const [disabledbutton, setDisabledButton] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const RoiCalculator = () => setRoiCalculatorOpen(true);
    const handleClose = () => setRoiCalculatorOpen(false);
    const farmAddress = getDrivenFarmAddress();
    const tokenAddress = getTokenAddress();

    useEffect(() => {
        setStakeValue("");
    }, [onClose]);

    useEffect(() => {
        // USDCalculation();
    }, [stackvalue]);
    const dispatch = useDispatch();
    const pidx = useSelector((state: any) => state.Index.processidx);

    const depositDVX = async () => {
        setDisabledButton(true);
        try {
            let tx;
            const farmContract = getContract(DrivenFarmABI, farmAddress, library.getSigner());
            tx = await farmContract.deposit(pool.pId, ethers.utils.parseEther(stackvalue));
            await tx.wait();
            dispatch(setPidx(pidx + 1))
            onClose();
        } catch (err) {
            console.log(err);
        }
        setDisabledButton(false);

    }
    const unStackDVX = async () => {
        setDisabledButton(true);
        try {
            let tx;
            const farmContract = getContract(DrivenFarmABI, farmAddress, library.getSigner());
            tx = await farmContract.withdraw(pool.pId, ethers.utils.parseEther(stackvalue));
            await tx.wait();
            dispatch(setPidx(pidx + 1))
            onClose();
        } catch (err) {
            console.log(err);
        }
        setDisabledButton(false);

    }
    const setPercentValue = (per) => {
        let bignumx = balance;
        console.log(bignumx)
        // let bignum = ((bignumx.mul(per)).div(100)).toString();
        // setStakeValue(ethers.utils.formatEther(bignum));
        setStakeValue(`${balance}`);
    }
    const changePercentage = (val) => {
        let bignum = ((parseFloat(val) / balance)) * 100;
        setPercentage(Math.ceil(bignum));
    }

    return (
        <>
            <Modal
                open={openfarmmodal}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                    }}>
                    <Box sx={{
                        width: 'auto',
                        // py: 4,
                        background: '#1A3342',
                        borderRadius: '32px',
                        maxHeight: '100vh',
                        zIndex: '100',
                        minWidth: '346px'
                    }}>

                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        color: '#00FED9',
                                    }}>
                                    {!isRemovingStake ? (`Stake ${pool.token0Symbol.toUpperCase()} - ${pool.token1Symbol.toUpperCase()}`) : (`Unstake ${pool.token0Symbol.toUpperCase()} - ${pool.token1Symbol.toUpperCase()}`)}
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>

                        <ModalBody>
                            <StyledBalanceInput>
                                <Box>
                                    <Box>
                                        <Flex justifyContent={"space-between"}>
                                            <Text color="#B1B3CB" bold>
                                                {!isRemovingStake ? ('Stake') : ('Unstake')}
                                            </Text>
                                            {/* <Text color="#B1B3CB" bold>Stake</Text> */}
                                            <Text ml="auto" color="textSubtle" fontSize="12px" mb="8px">
                                                <Balance
                                                    fontSize="14px"
                                                    color="#B1B3CB"
                                                    textAlign="right"
                                                    decimals={10}
                                                    // value={pool.lpToken.balanceOf()}
                                                    value={balance}
                                                    // value={453}
                                                    unit=" "
                                                    prefix="Balance: "
                                                />
                                            </Text>


                                        </Flex>
                                        <Flex justifyContent={'space-between'}>
                                            <Box>
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min={0}
                                                    placeholder={'0.0'}
                                                    value={stackvalue}
                                                    onChange={(e) => { setStakeValue(e.target.value); changePercentage(e.target.value ? balance : '0') }}
                                                />
                                            </Box>
                                            <Box sx={{ display: 'flex' }}>
                                                <PercentageButton onClick={() => setPercentValue(100)} sx={{ mt: 1 }}>Max</PercentageButton>
                                                {/* <Box sx={{ fontSize: "14px", color: "#B1B3CB", mt: 1.5, textTransform: 'uppercase' }}>{`${pool.token1Symbol}-${pool.token0Symbol}`}</Box> */}
                                            </Box>

                                        </Flex>

                                    </Box>

                                </Box>
                            </StyledBalanceInput>
                            {!isRemovingStake ?

                                <Flex mt="24px" alignItems="center" justifyContent="space-between">
                                    <Text mr="8px" color="white">
                                        Annual ROI at current rates:
                                    </Text>
                                    <AnnualRoiContainer
                                        alignItems="center"
                                        onClick={() => {
                                            RoiCalculator()
                                        }}
                                    >
                                        <AnnualRoiDisplay color="white">{pool.apr.toFixed(2)}%</AnnualRoiDisplay>
                                        <IconButton variant="text" scale="sm">
                                            <CalculateIcon color="#00FED9" width="18px" />
                                        </IconButton>
                                    </AnnualRoiContainer>


                                </Flex>

                                :
                                <>
                                </>
                            }


                            <Box sx={{ display: 'flex' }}>
                                <StyledLink external>
                                    <GetSymbol onClick={onClose}>
                                        Cancel
                                    </GetSymbol>
                                </StyledLink>
                                <ConfirmButton sx={{ mt: 3, ml: 3 }} onClick={() => { isRemovingStake ? unStackDVX() : depositDVX() }} disabled={disabledbutton || (stackvalue) == '' || parseFloat(stackvalue) > balance || parseFloat(stackvalue) <= 0}>
                                    Confirm {disabledbutton && <Box><LoopIcon className="animation-spin" sx={{ width: '18px', height: '18px' }} /></Box>}
                                </ConfirmButton>
                                {/* <ConfirmButton sx={{ mt: 3, ml: 3 }} onClick={() => { isRemovingStake ? unStackDVX() : depositDVX() }} disabled={disabledbutton || parseFloat(stackvalue) <= 0 || stackvalue == "" || parseFloat(stackvalue) > parseFloat(ethers.utils.formatEther(stack))}  >
                                    Confirm
                                </ConfirmButton> */}
                            </Box>
                            {!isRemovingStake ?

                                <>

                                    <GetToken external href={'https://pancakeswap.finance/add/BNB/0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e'}>
                                        <GetSymbol>
                                            Get DVX-BNB
                                        </GetSymbol>
                                    </GetToken>

                                    {/* <PLinkExternal href={''} bold={false}  color='#00FED9'>
                                        <Text fontSize="14px" color='white' >
                                            See Token Info
                                        </Text>
                                    </PLinkExternal> */}
                                </>

                                :
                                <>
                                </>
                            }


                        </ModalBody>
                    </Box>
                </Box>
            </Modal>
            <FarmRoiCalculatorModal open={RoiCalculatoropen} onClose={handleClose} pool={pool} stackvalue={stackvalue} usdvalue={usdvalue}></FarmRoiCalculatorModal>
        </>
    );
};

export default StakeFarmModal;
